// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print-optimized-image {
    width: 90%;
    object-fit: contain;
}

.shap-summary-plot,
.shap-heatmap-plot,
.shap-waterfall-plot,
.mean-shap-plot,
.forceplot-for {
    min-width: 20vw;
    max-width: 1200px;
    height: auto;
    object-fit: contain;
    display: block;
}

.shap-waterfall-plot {
    width: 60vw;
    margin-left: 25vw;
}

.forceplot-for {
    width: 50vw;
    margin-left: 25vw;
}

.shap-summary-plot {
    width: 30vw;
    margin-left: 5vw;
}

.shap-heatmap-plot {
    width: 40vw;
    margin-left: 10vw;
}

.mean-shap-plot {
    width: 30vw;
    margin-left: 5vw;
}

/* Modal Styles - Enhanced */
.modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75); /* Darker background */
    overflow: auto;
}

/* Adjust image size inside modal containing large image */
.modal img {
    max-width: 100%;
    max-height: 80vh;
    border-radius: 8px;
}

.modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 85%;
    max-width: 1000px;
    max-height: 85vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
}

.modal-content img {
    max-width: 90%;
    max-height: 90vh;
    margin: 0 auto;
    display: block;
} 

/* Zoom Modal - Specialized Styles */
.zoom-modal {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: fixed !important;
    z-index: 1000 !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: rgba(0, 0, 0, 0.8) !important; /* Darker background for zoom modal */
    overflow: auto !important;
}
  
.zoom-modal-content {
    background-color: #fefefe !important;
    margin: auto !important;
    padding: 20px !important;
    border-radius: 8px !important;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
    width: 85% !important;
    max-width: 1100px !important;
    max-height: 90vh !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
}
  
/* Close Button */
.close {
    color: #666;
    float: right;
    font-size: 28px;
    font-weight: bold;
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 10;
}
  
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

/* Zoom Controls section for instructions and options */
.zoom-controls {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 5px;
    font-size: 14px;
}
  
.zoom-controls h3 {
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 16px;
    color: #333;
}
  
.zoom-controls ul {
    margin: 0;
    padding-left: 20px;
}
  
.zoom-controls li {
    margin-bottom: 3px;
}
  
/* Zoom Buttons for controlling zoom in/out */
.zoom-buttons {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    gap: 10px;
}
  
.zoom-buttons button {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 15px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;
}
  
.zoom-buttons button:hover {
    background-color: #0056b3;
}

/* Added later: Container for zoomed image */
.image-container {
  flex: 1 1;
  overflow: auto;
  width: 100%;
  height: calc(90vh - 80px);
  display: flex;
}

`, "",{"version":3,"sources":["webpack://./src/css/step8_1-zoomGraph.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;;;;;IAKI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,qCAAqC,EAAE,sBAAsB;IAC7D,cAAc;AAClB;;AAEA,0DAA0D;AAC1D;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,+CAA+C,EAAE,qCAAqC;IACtF,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,oDAAoD;IACpD,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA,uDAAuD;AACvD;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,SAAO;EACP,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf","sourcesContent":[".print-optimized-image {\n    width: 90%;\n    object-fit: contain;\n}\n\n.shap-summary-plot,\n.shap-heatmap-plot,\n.shap-waterfall-plot,\n.mean-shap-plot,\n.forceplot-for {\n    min-width: 20vw;\n    max-width: 1200px;\n    height: auto;\n    object-fit: contain;\n    display: block;\n}\n\n.shap-waterfall-plot {\n    width: 60vw;\n    margin-left: 25vw;\n}\n\n.forceplot-for {\n    width: 50vw;\n    margin-left: 25vw;\n}\n\n.shap-summary-plot {\n    width: 30vw;\n    margin-left: 5vw;\n}\n\n.shap-heatmap-plot {\n    width: 40vw;\n    margin-left: 10vw;\n}\n\n.mean-shap-plot {\n    width: 30vw;\n    margin-left: 5vw;\n}\n\n/* Modal Styles - Enhanced */\n.modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    z-index: 1000;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.75); /* Darker background */\n    overflow: auto;\n}\n\n/* Adjust image size inside modal containing large image */\n.modal img {\n    max-width: 100%;\n    max-height: 80vh;\n    border-radius: 8px;\n}\n\n.modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    width: 85%;\n    max-width: 1000px;\n    max-height: 85vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.modal-content img {\n    max-width: 90%;\n    max-height: 90vh;\n    margin: 0 auto;\n    display: block;\n} \n\n/* Zoom Modal - Specialized Styles */\n.zoom-modal {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    position: fixed !important;\n    z-index: 1000 !important;\n    left: 0 !important;\n    top: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n    background-color: rgba(0, 0, 0, 0.8) !important; /* Darker background for zoom modal */\n    overflow: auto !important;\n}\n  \n.zoom-modal-content {\n    background-color: #fefefe !important;\n    margin: auto !important;\n    padding: 20px !important;\n    border-radius: 8px !important;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;\n    width: 85% !important;\n    max-width: 1100px !important;\n    max-height: 90vh !important;\n    overflow: hidden !important;\n    display: flex !important;\n    flex-direction: column !important;\n    position: relative !important;\n}\n  \n/* Close Button */\n.close {\n    color: #666;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n    position: absolute;\n    top: 10px;\n    right: 20px;\n    z-index: 10;\n}\n  \n.close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n/* Zoom Controls section for instructions and options */\n.zoom-controls {\n    margin-bottom: 15px;\n    padding: 10px;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n    font-size: 14px;\n}\n  \n.zoom-controls h3 {\n    margin-top: 0;\n    margin-bottom: 5px;\n    font-size: 16px;\n    color: #333;\n}\n  \n.zoom-controls ul {\n    margin: 0;\n    padding-left: 20px;\n}\n  \n.zoom-controls li {\n    margin-bottom: 3px;\n}\n  \n/* Zoom Buttons for controlling zoom in/out */\n.zoom-buttons {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 10px;\n    gap: 10px;\n}\n  \n.zoom-buttons button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 5px 15px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n  \n.zoom-buttons button:hover {\n    background-color: #0056b3;\n}\n\n/* Added later: Container for zoomed image */\n.image-container {\n  flex: 1;\n  overflow: auto;\n  width: 100%;\n  height: calc(90vh - 80px);\n  display: flex;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
